import { orderBy, Identifier } from 'natural-orderby'

const identityFn = (x: any): string => x

export function values<T>(obj: Record<string, T>): T[] {
  return Array.prototype.concat.apply([], Object.values(obj))
}

export const sortBy = <T>(
  l: Array<T> | ArrayLike<T>,
  fn: Array<Identifier<T>> | Identifier<T> = identityFn,
  order: 'asc' | 'desc' | Array<'asc' | 'desc'> = 'asc'
): Array<T> =>
  orderBy(Array.from(l ?? []), Array.isArray(fn) ? fn : [fn], order)

type DropdownOption = {
  label: string
  value: string
  group?: string
}

type DropdownGetter = (x: any) => string

export const getDropdownOptions = (
  list = [],
  getLabel: DropdownGetter = identityFn,
  getValue: DropdownGetter = identityFn,
  sortByIteratee: (option: DropdownOption) => string = ({ label }) => label,
  getGroup?: (item: any) => string
): any[] => {
  const newList: DropdownOption[] = list.map(item => {
    const obj: DropdownOption = {
      label: getLabel(item),
      value: getValue(item)
    }

    if (typeof getGroup === 'function') {
      obj.group = getGroup(item)
    }
    return obj
  })
  return sortBy(newList, sortByIteratee)
}

export const last = <T>(array: T[]): T | undefined => {
  return Array.isArray(array) ? array[array.length - 1] : undefined
}

export const unique = <T>(array: T[]): T[] => Array.from(new Set(array))

export const isLastIndex = (list: any[], index: number): boolean =>
  index === list.length - 1

export const hasTruthy = (...list: any[]): boolean => list.flat().some(Boolean)

export function intersect<T>(left: T[] = [], right: T[] = []): T[] {
  if (left.length === 0 || right.length === 0) {
    return []
  }
  let arrToFilter
  let setToMap

  // find out which arr length is less
  // and filter it

  if (left.length < right.length) {
    arrToFilter = left
    setToMap = new Set(right)
  } else {
    arrToFilter = right
    setToMap = new Set(left)
  }

  return arrToFilter.filter(item => setToMap.has(item))
}

export const intersection = <T>(list: T[][] = []): T[] => {
  if (list.length === 0) {
    return []
  }

  let curList = list[0]
  for (let i = 0; i < list.slice(1).length; i++) {
    if (list[i].length === 0) {
      return []
    }
    curList = intersect(curList, list[i])
  }

  return curList
}
